<!-- Две половины компактного сегмента титула: заполнение и подпись. -->
<template>
  <span class="edo-flow-segment" aria-hidden="true">
    <span
      v-for="(step, index) in steps"
      :key="step?.key || index"
      class="edo-flow-segment__half"
      :class="`edo-flow-segment__half--${stepTone(step)}`"
    ></span>
  </span>
</template>

<script>
export default {
  name: "EdoDocumentFlowSegment",

  props: {
    steps: {
      type: Array,
      required: true,
    },
    groupTone: {
      type: String,
      default: "neutral",
    },
    activeStepKey: {
      type: String,
      default: "",
    },
  },

  methods: {
    stepTone(step) {
      // Backend может выбрать blocked/planned шаг текущей точкой процесса.
      // activeStepKey позволяет подсветить именно его, не угадывая по порядку.
      if (
        step?.key === this.activeStepKey &&
        this.groupTone === "warning"
      ) return "warning";

      return step?.tone || "neutral";
    },
  },
};
</script>

<style scoped>
.edo-flow-segment {
  display: flex;
  flex: 0 0 28px;
  gap: 1px;
  width: 28px;
  height: 8px;
  overflow: hidden;
  border-radius: 3px;
}

.edo-flow-segment__half {
  flex: 1 1 0;
  min-width: 0;
  background: #c4cad6;
}

.edo-flow-segment__half--success {
  background: var(--color-green);
}

.edo-flow-segment__half--warning {
  background: #f59e0b;
}

.edo-flow-segment__half--danger {
  background: var(--color-danger);
}
</style>
